import $ from "jquery";
import { showToast } from "./modals";
import { TargetTypeOption } from "./multi-select-dropdown";
import { CHANNEL_TARGET_REGEX, moduleConfigs } from "./constants";
import { UpdateWithInputCellRenderer } from "@cell-renderers/AllCellRenderers";
import {
    createNegativeKeywords,
    createKeywords,
    getCampaigns,
    getAdGroups,
    createWorkers,
    getDefaultBid,
    validateCreateKeywords,
    updateKeywords,
    setSpinner,
    getReviewedKeywords,
} from "./utils";
import store from "../store";
import { updateKeywordsSelectionData } from "@features/selectedDataSlice";
import React, { KeyboardEvent, MouseEvent } from "react";
import { ColDef, GridApi } from "ag-grid-community";
import {
    ChannelName,
    Channels,
    BULK_TGT_ACTION,
    ICreateReviewKeywords,
    IProps,
    TBulkActionsFooterBtnValues,
    TCommonRowData,
    TCommonRowObj,
    TKeywordsActionObj,
    ProgramType,
    MatchType,
    ActionLevel,
    StateTypeValues,
} from "./common-types";
import { removeDuplicateObjects } from "@workers/bulk-keywords.worker";
import { updateShowCreateKeywordsReviewDisplay } from "../features/modalSlice";
import { filter, find, forEach, map } from "underscore";
import {
    setCreateKeywordsData,
    setCreateKeywordsReviewData,
} from "../features/gridDataSlice";
import { CHANNEL_CONFIGS } from "@/config/channel-configs";

type TSelectedValue = {
    label: string;
    value: string;
};

interface TCampaign {
    [key: string]: string;
    campaign_id?: string;
    channel_campaign_name?: string;
    program_type?: string;
    sys_campaign_id?: string;
}

type TAdGroup = {
    [key: string]: string;
    ad_group_id?: string;
    campaign_id?: string;
    targeting_type?: string;
    manual_targeting_type?: string;
    keyword_type?: string;
    ad_group_name?: string;
    sys_adgroup_id?: string;
    sys_campaign_id?: string;
};

let actionType: string;
let selectedPortfolioArray: Array<string> = [];
let selectedCampaignArray: Array<string> = [];
let selectedAdgroupArray: Array<string> = [];
let matchTypeArray: Array<string> = [];

export const selectAllOption = { value: "*", label: "Select All" };
export const clientCampaignsOptions: Array<TargetTypeOption> = [
    selectAllOption,
];
export const adgroupOptions: Array<TargetTypeOption> = [selectAllOption];

const actions = Object.freeze({
    addAsKeyword: "addAsKeyword",
    addAsNegativeKeyword: "addAsNegativeKeyword",
});

export const getCampaignsOfPortfolios = async (
    selectedPortfolios: Array<TSelectedValue>,
    selectedProgramType: Array<TSelectedValue>,
    selectedCampaignType: Array<TSelectedValue>,
    setClientCampaignOptions: React.Dispatch<
        React.SetStateAction<Array<TargetTypeOption>>
    >
) => {
    try {
        $("#confirm-campaign-filter").prop("disabled", true);
        const currentTargets = store.getState().keywordsSelectionData.value;
        const selectedCampaignTypeArray: Array<string> = [];
        const selectedProgramTypeArray: Array<string> = [];
        const channel = store.getState().channel.value;
        selectedPortfolioArray = [];
        if (currentTargets.length) {
            selectedPortfolios.forEach((portfolio: TSelectedValue) => {
                selectedPortfolioArray.push(portfolio.value);
            });
            selectedPortfolioArray = selectedPortfolioArray.filter(
                (value) => value !== "*"
            );

            selectedCampaignType.forEach((campaigns: TSelectedValue) => {
                selectedCampaignTypeArray.push(campaigns.value);
            });
            selectedProgramType.forEach((program: TSelectedValue) => {
                selectedProgramTypeArray.push(program.value);
            });

            let clientCampaigns = [];
            // const applyFilters = (selectedPortfolioArray.length && !selectedPortfolioArray.includes("none"))
            //     || selectedCampaignTypeArray.length || selectedProgramTypeArray.length;

            selectedCampaignArray = [];

            const filterArray =
                channel === Channels.AMAZON
                    ? [
                          {
                              prop: "portfolio_id",
                              data: selectedPortfolioArray,
                              prefix: "acs",
                          },
                          {
                              prop: "program_type",
                              data: selectedProgramTypeArray,
                              prefix: "acs",
                          },
                          {
                              prop: "targetingtype",
                              data: selectedCampaignTypeArray,
                              prefix: "acs",
                          },
                      ]
                    : [
                          {
                              prop: "program_type",
                              data: selectedProgramTypeArray,
                              prefix: "acs",
                          },
                      ];

            clientCampaigns = await getCampaigns(filterArray, actionType);

            if (!clientCampaigns) {
                throw new Error("Could not get client specific campaigns");
            }

            clientCampaignsOptions.splice(1, clientCampaignsOptions.length);
            clientCampaigns.forEach((campaign: TCampaign) => {
                const options: TSelectedValue = {
                    value: campaign.sys_campaign_id,
                    label: campaign.channel_campaign_name,
                };
                clientCampaignsOptions.push(options);
            });
            setClientCampaignOptions(clientCampaignsOptions);

            $("#confirm-campaign-filter").prop("disabled", false);
        } else {
            showToast(
                "danger",
                "Please select at least one keyword or enter a custom keyword."
            );
        }
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
    }
};

async function getCampaignSpecificAdgroup(selectedCampaignData: Array<string>) {
    selectedCampaignData = selectedCampaignData.filter((data) => data !== "*");
    try {
        const campaignSpecificAdgroups = await getAdGroups({
            and: {
                sys_campaign_id: [...selectedCampaignData],
            },
        });

        window.sessionStorage.setItem(
            "campaignAdgroupMapping",
            JSON.stringify(campaignSpecificAdgroups)
        );
        return campaignSpecificAdgroups;
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
    }
}

function partitionAdgroupsOnProgramType(adgroupArray: Array<TAdGroup>) {
    const sponsoredBrandAdgroups: Array<TAdGroup> = [];
    const campaignList = JSON.parse(
        window.sessionStorage.getItem("campaignList")
    );
    const campaignProgramType = (campaignId: string) =>
        campaignList.filter(
            (campaignInfo: TCampaign) => campaignInfo.campaign_id === campaignId
        )[0].program_type;

    const restAdgroups = adgroupArray.filter((adgroupInfo: TAdGroup) => {
        if (campaignProgramType(adgroupInfo.campaign_id).toLowerCase() !== "sb")
            return adgroupInfo;
        else {
            /**
             * !code modified due to es-lint error discuss with Mritunjay
             *  */

            sponsoredBrandAdgroups.push(adgroupInfo);
            return [];
        }
    });

    sponsoredBrandAdgroups.length
        ? window.sessionStorage.setItem(
              "sponsoredBrandAdgroups",
              JSON.stringify(sponsoredBrandAdgroups)
          )
        : window.sessionStorage.removeItem("sponsoredBrandAdgroups");
    return restAdgroups;
}

function onlySBCampaigns() {
    const selectedCampaignsId = JSON.parse(
        window.sessionStorage.getItem("campaignAdgroupMapping")
    ).reduce(
        (acc: Array<string>, campaignObject: TCampaign) =>
            (acc = [...acc, campaignObject.campaign_id]),
        []
    );

    const campaignList = JSON.parse(
        window.sessionStorage.getItem("campaignList")
    );

    const selectedCampaignProgramType = campaignList
        .filter((campaignInfoObject: TCampaign) =>
            selectedCampaignsId.includes(campaignInfoObject.campaign_id)
        )
        .map(
            (selectedCampaignInfo: TCampaign) =>
                selectedCampaignInfo.program_type
        );
    //@ts-ignore
    const uniqueProgramTypeArray = [...new Set(selectedCampaignProgramType)];
    return (
        uniqueProgramTypeArray.length === 1 &&
        uniqueProgramTypeArray.includes("sb")
    );
}

export function isTarget(str: string) {
    const channel = store.getState().channel.value;
    const channelName = CHANNEL_CONFIGS[channel].name;
    return moduleConfigs[channelName as ChannelName].options
        .isTargetCheckRequired
        ? CHANNEL_TARGET_REGEX[channel].test(str.toLowerCase())
        : false;
}

export function checkForKeywordOrTarget(
    selectedKeywordArray: TCommonRowData,
    entity_name = "keyword_name"
) {
    //- ASIN shall start with b0
    //- ASIN should be 10 character in total
    //- ASIN is alpha-numeric
    //- ASIN is one single word, no spaces
    return selectedKeywordArray.map((keyword: TCommonRowObj) => ({
        ...keyword,
        keyword_type: isTarget(keyword[entity_name] as string)
            ? "asin"
            : "keyword",
    }));
}

export const confirmCampaignsHandler = async (
    selectedClientCampaigns: Array<Record<string, string>>,
    setAdGroupOptions: React.Dispatch<
        React.SetStateAction<Array<TargetTypeOption>>
    >,
    setFooterBtnValues: React.Dispatch<
        React.SetStateAction<TBulkActionsFooterBtnValues>
    >,
    setIsShowMatchType: React.Dispatch<React.SetStateAction<boolean>>
) => {
    $("#confirm-campaigns").prop("disabled", true);
    // resetAdgroupSelection();
    // ! Reset select-campaigns-array on clicking of get-adgroups button
    selectedCampaignArray.length = 0;
    selectedClientCampaigns.forEach((campaign) => {
        const value = campaign.value;
        selectedCampaignArray.push(value);
    });
    selectedCampaignArray = selectedCampaignArray.filter(
        (value) => value !== "*"
    );

    const campaignSpecificAdgroup = await getCampaignSpecificAdgroup(
        selectedCampaignArray
    );

    if (campaignSpecificAdgroup.length) {
        //- Forbid SB and SBV campaigns adgroups from adding into the options.
        //- However they will be selected, if and only if user has selected SB campaigns, meaning if SB adgroups are fetched, they are selected by default
        const nonSBAdgroups = partitionAdgroupsOnProgramType(
            campaignSpecificAdgroup
        );

        //- Check if ONLY SB campaigns are selected or not.
        //- If yes, directly ask the "match type"
        if (!onlySBCampaigns()) {
            adgroupOptions.splice(1, adgroupOptions.length);
            nonSBAdgroups.forEach((adgroup) => {
                const value = {
                    value: adgroup.sys_adgroup_id,
                    label: adgroup.ad_group_name,
                };
                adgroupOptions.push(value);
            });
            setAdGroupOptions(adgroupOptions);
        } else {
            const selectedKeywords =
                store.getState().keywordsSelectionData.value;
            const keywords = checkForKeywordOrTarget(selectedKeywords);
            const showMatchTypeDropdown = keywords.filter(
                (keyword) => keyword.keyword_type === "keyword"
            ).length;
            const campaignAdgroupMapping = JSON.parse(
                window.sessionStorage.getItem("campaignAdgroupMapping")
            );

            if (showMatchTypeDropdown) {
                setIsShowMatchType(true);
                if (matchTypeArray.length > 0 && selectedKeywords.length > 0) {
                    setFooterBtnValues((prev) => ({
                        ...prev,
                        isReviewSelectionBtnDisabled: false,
                    }));
                }
            } else {
                //- only ASINs are present and campaigns are of SB type.
                //- Always select all the adgroups fetched in SB campaigns
                setIsShowMatchType(false);

                campaignAdgroupMapping && campaignAdgroupMapping.length
                    ? campaignAdgroupMapping.forEach(
                          (campaignAdgroupObject: Record<string, string>) =>
                              selectedAdgroupArray.push(
                                  campaignAdgroupObject.sys_adgroup_id
                              )
                      )
                    : showToast(
                          "danger",
                          "No adgroups found for the selected campaigns"
                      );

                selectedAdgroupArray.length
                    ? setFooterBtnValues((prev) => ({
                          ...prev,
                          isReviewSelectionBtnDisabled: false,
                      }))
                    : setFooterBtnValues((prev) => ({
                          ...prev,
                          isReviewSelectionBtnDisabled: true,
                      }));
            }
        }
        $("#confirm-campaigns").prop("disabled", false);
    } else {
        setAdGroupOptions([]);
        showToast("danger", "No adgroups found for selected campaigns");
    }
};

export function togglePillContainer() {
    const pillContainerDisplay = $(".pillContainer").css("display");
    if (pillContainerDisplay === "none") {
        $(".pillContainer").css({
            display: "flex",
        });
        $("#keyword-analytics-first-step").css({
            filter: "blur(10px)",
        });
    } else {
        $(".pillContainer").css({
            display: "none",
        });
        $("#keyword-analytics-first-step").css({
            filter: "blur(0)",
        });
    }
}

const removeCurrentTargetPill = (pillInputId: string) => {
    const targetElement = $(`#${pillInputId}`).parent();
    const eliminatedTargetName = pillInputId;
    const selectedKeywords = JSON.parse(
        window.sessionStorage.getItem("unsavedSelectedData")
    );
    type TTarget = { keyword_name: string };
    const eligibleTargets = selectedKeywords.filter(
        (target: TTarget) => target.keyword_name !== eliminatedTargetName
    );
    window.sessionStorage.setItem(
        "unsavedSelectedData",
        JSON.stringify(eligibleTargets)
    );
    targetElement[0].remove();
    const totalCustomTargetPillCount =
        document.getElementsByClassName("pillBody")[0].childElementCount;
    if (!totalCustomTargetPillCount) {
        document.getElementById("add-custom-targets").style.display = "none";
        (
            document.getElementById("add-custom-targets") as HTMLButtonElement
        ).disabled = true;
        document.getElementById("remove-custom-targets").style.display = "none";
    }
};

export function removeCustomTargetBtnHandler() {
    document.getElementsByClassName("pillBody")[0].innerHTML = "";
    (
        document.getElementsByClassName("pillContainer")[0] as HTMLDivElement
    ).style.display = "none";
    const currentTargets = store.getState().keywordsSelectionData.value;
    store.dispatch(
        updateKeywordsSelectionData(
            currentTargets.filter((target) => !target.custom)
        )
    );
    appendKeywordsInformation();
    document.getElementById("remove-custom-targets").style.display = "none";
}

function createPillInput(pillInputValue: string) {
    document.getElementById("add-custom-targets").style.display = "unset";
    (
        document.getElementById("add-custom-targets") as HTMLButtonElement
    ).disabled = false;

    const pillInputId = pillInputValue.split(" ").join("-") + "-target-pill";
    document.getElementsByClassName("pillBody")[0].innerHTML += `
    <div class="badge border bg-light fw-normal text-dark d-flex align-items-center m-1" id=${pillInputId}>
        <span class="ellipsis" title="${pillInputValue}" style="width:${
        pillInputValue.length > 35 ? "25ch" : null
    }">${pillInputValue}</span>
        <i class="times filter-pill" style="font-size:12px; cursor:pointer; margin-left:3px" aria-hidden="true" id=${pillInputValue}></i>
    </div>`;

    let currentTargets = JSON.parse(
        window.sessionStorage.getItem("unsavedSelectedData")
    );
    if (currentTargets && currentTargets.length) {
        currentTargets.push({ keyword_name: pillInputValue, custom: true });
    } else {
        currentTargets = [];
        currentTargets.push({ keyword_name: pillInputValue, custom: true });
    }
    window.sessionStorage.setItem(
        "unsavedSelectedData",
        JSON.stringify(currentTargets)
    );
}

export const addCustomTargetBtnHandler = () => {
    togglePillContainer();
    document.getElementsByClassName("pillBody")[0].innerHTML = "";
    document.getElementById("add-custom-targets").style.display = "none";
    (
        document.getElementById("add-custom-targets") as HTMLButtonElement
    ).disabled = true;
    const unsavedSelectedData = JSON.parse(
        window.sessionStorage.getItem("unsavedSelectedData")
    );
    const selectedData = store.getState().keywordsSelectionData.value;

    if (selectedData) {
        store.dispatch(
            updateKeywordsSelectionData([
                ...unsavedSelectedData,
                ...selectedData,
            ])
        );
    } else {
        store.dispatch(updateKeywordsSelectionData(unsavedSelectedData));
    }
    window.sessionStorage.removeItem("unsavedSelectedData");
    appendKeywordsInformation();
    document.getElementById("remove-custom-targets").style.display = "unset";
};

export const handleEnterKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        const keywords = (e.target as HTMLInputElement).value
            .split("\n")
            .filter((data) => data.trim().length !== 0);
        if (keywords.length) {
            keywords.forEach((value: string) => {
                createPillInput(value);
                const pillsArr = document.querySelectorAll(".filter-pill");
                pillsArr.forEach((pill) => {
                    pill.addEventListener("click", () => {
                        removeCurrentTargetPill(pill.id);
                    });
                });
            });
        } else {
            showToast(
                "danger",
                "Please insert a target and press enter for adding custom targets."
            );
        }
        (e.target as HTMLInputElement).value = "";
    }
};

export const appendKeywordsInformation = (charLimit = 50) => {
    const selectedData = store.getState().keywordsSelectionData.value;
    const keywordDisplayDiv = $(".selectedKeywords");
    keywordDisplayDiv[0].innerHTML = "";

    $(".selectedKeyword").find("span").remove();

    selectedData.forEach((keyword) => {
        keywordDisplayDiv[0].innerHTML += `<span class="selected-filter badge border bg-light fw-normal text-dark ms-1 mt-1 position-relative">${(
            keyword.keyword_name || ""
        ).substring(0, charLimit)}</span>`;
    });
};

export const resetDynamicOptions = () => {
    clientCampaignsOptions.splice(1, clientCampaignsOptions.length);
    adgroupOptions.splice(1, adgroupOptions.length);
};

export function actionBtnClickHandler(
    event: MouseEvent<HTMLButtonElement>,
    resetToInitialState: () => void,
    setIsShowMatchType: React.Dispatch<React.SetStateAction<boolean>>
) {
    const btnId = (event.target as HTMLButtonElement).id;
    setIsShowMatchType(false);
    resetToInitialState();

    switch (btnId) {
        case "add-keyword-btn":
            actionType = actions.addAsKeyword;
            break;

        case "add-negative-keyword-btn":
            actionType = actions.addAsNegativeKeyword;
            break;

        default:
            console.error("Invalid action performed");
    }
}

export const adgroupChangeHandler = (props: IProps) => {
    const selectedKeywords = store.getState().keywordsSelectionData.value;
    if (selectedKeywords && selectedKeywords.length) {
        const keywords = checkForKeywordOrTarget(selectedKeywords);
        const showMatchTypeDropdown = keywords.filter(
            (keyword) => keyword.keyword_type === "keyword"
        ).length;
        selectedAdgroupArray.length = 0;
        adgroupOptions.forEach((options) => {
            selectedAdgroupArray.push(options.value);
        });
        selectedAdgroupArray = selectedAdgroupArray.filter(
            (value) => value !== "*"
        );

        if (showMatchTypeDropdown) {
            props.setIsShowMatchType(true);
            if (matchTypeArray.length > 0 && selectedKeywords.length > 0) {
                props.setFooterBtnValues((prev) => ({
                    ...prev,
                    isReviewSelectionBtnDisabled: false,
                }));
            }
        } else {
            props.setIsShowMatchType(false);
            if (selectedAdgroupArray.length) {
                props.setFooterBtnValues((prev) => ({
                    ...prev,
                    isReviewSelectionBtnDisabled: false,
                }));
            } else {
                props.setFooterBtnValues((prev) => ({
                    ...prev,
                    isReviewSelectionBtnDisabled: true,
                }));
            }
        }
    }
};

export const matchTypeChangeHandler = (
    selectedOptions: Array<TSelectedValue>,
    props: IProps
) => {
    const isMatchTypeSelected = !!selectedOptions.length;
    isMatchTypeSelected
        ? props.setFooterBtnValues((prev) => ({
              ...prev,
              isReviewSelectionBtnDisabled: false,
          }))
        : props.setFooterBtnValues((prev) => ({
              ...prev,
              isReviewSelectionBtnDisabled: true,
          }));
};

export const campaignChangeHandler = (
    selectedOptions: Array<TSelectedValue>,
    props: IProps
) => {
    selectedCampaignArray.length = 0;
    selectedOptions.forEach((campaign) => {
        selectedCampaignArray.push(campaign.value);
    });

    const selectedKeywords = store.getState().keywordsSelectionData.value;

    if (selectedKeywords && selectedKeywords.length) {
        const keywords = checkForKeywordOrTarget(selectedKeywords);
        const showMatchTypeDropdown = keywords.filter(
            (keyword) => keyword.keyword_type === "keyword"
        ).length;
        if (selectedCampaignArray.length) {
            if (props.actionLevel === "campaign") {
                if (showMatchTypeDropdown) {
                    props.setIsShowMatchType(true);
                    if (
                        matchTypeArray.length > 0 &&
                        selectedKeywords.length > 0
                    ) {
                        props.setFooterBtnValues((prev) => ({
                            ...prev,
                            isReviewSelectionBtnDisabled: false,
                        }));
                    }
                } else {
                    props.setIsShowMatchType(false);
                    props.setFooterBtnValues((prev) => ({
                        ...prev,
                        isReviewSelectionBtnDisabled: false,
                    }));
                }
            }
            if (!props.isMatchTypeSelectionRequired) {
                props.setIsShowMatchType(false);
                props.setFooterBtnValues((prev) => ({
                    ...prev,
                    isReviewSelectionBtnDisabled: false,
                }));
            }
            if (!props.isAdgroupSelectionRequired) {
                //bypass adgroup selection and go directly to matchtype selection
                props.setIsShowMatchType(true);
            }
        } else {
            props.setIsShowMatchType(false);
            props.setFooterBtnValues((prev) => ({
                ...prev,
                isReviewSelectionBtnDisabled: true,
            }));
        }
    }
};

interface IConfig {
    actionLevel: string | number | Array<string>;
    currentProgramType: string;
    currentKeywordType: string;
    isAdgroupSelectionRequired: boolean;
}

function isAdgroupInfoRequired(config: IConfig) {
    // If actionLevel is "campaign" and programType is "SP", adgroup is not required for keywords.
    // If actionLevel is "campaign" and programType is "SP", adgroup is required for targets.
    // If actionLevel is "campaign" and ProgramType is "SB", adgroup is required for both keywords and targets.
    // Keep isAdgroupSelectionRequired: false for channels where there are no adgroups

    if (!config.isAdgroupSelectionRequired) {
        return false;
    }

    if (
        config.actionLevel === "campaign" &&
        config.currentProgramType === "sp"
    ) {
        return config.currentKeywordType === "asin";
    }
    return true;
}

async function createBulkKeywordObject(
    selectedCampaignData: Array<string>,
    selectedAdgroupData: Array<string>,
    actionLevel: string,
    isAdgroupSelectionRequired: boolean,
    isBidRequired: boolean
) {
    selectedAdgroupData =
        selectedAdgroupData && selectedAdgroupData.length
            ? selectedAdgroupData
            : [];

    const bulkKeywordArray = bulkOperationKeywordObject({
        selectedCampaignData,
        selectedAdgroupData,
        matchTypeData: matchTypeArray,
        action: actionType,
        actionLevel,
        isAdgroupSelectionRequired,
        isBidRequired,
    });
    return bulkKeywordArray;
}

function createKeywordActionObject({
    keywordText,
    programType,
    keywordType,
    campaignId,
    channel_campaign_name,
    adGroupId,
    ad_group_name,
    matchTypeData,
    state,
    action,
    bid,
    sysCampaignId,
    sysAdgroupId,
    targeting_type,
}: TKeywordsActionObj) {
    const negativeMatchType: Record<string, string> = {
        phrase: MatchType.NEGATIVE_PHRASE,
        exact: MatchType.NEGATIVE_EXACT,
    };

    const keywordActionObject = {
        keywordText,
        programType,
        keywordType,
        campaignId,
        channel_campaign_name,
        targeting_type,
        ...(programType === ProgramType.SP && { state }),
        ...(action === actions.addAsKeyword && { bid }),
        ...(adGroupId && { adGroupId }),
        ...(ad_group_name && { ad_group_name }),
        ...(sysCampaignId && { sysCampaignId }),
        ...(sysAdgroupId && { sysAdgroupId }),
        attribute:
            action === actions.addAsKeyword
                ? ["create_target"]
                : ["create_negative_target"],
    };

    const keywordActionObjectArray = [];

    if (matchTypeData.length) {
        if (keywordType === "keyword") {
            matchTypeData.forEach((matchType) => {
                const shallowKeywordActionObject: TKeywordsActionObj = {
                    ...keywordActionObject,
                };
                shallowKeywordActionObject["matchType"] =
                    action === actions.addAsKeyword
                        ? matchType
                        : negativeMatchType[matchType];
                keywordActionObjectArray.push(shallowKeywordActionObject);
            });
        } else {
            const shallowKeywordActionObject: TKeywordsActionObj = {
                ...keywordActionObject,
            };
            shallowKeywordActionObject["matchType"] = "asinSameAs";
            keywordActionObjectArray.push(shallowKeywordActionObject);
        }
    } else {
        const shallowKeywordActionObject: TKeywordsActionObj = {
            ...keywordActionObject,
        };
        shallowKeywordActionObject["matchType"] = "asinSameAs";
        keywordActionObjectArray.push(shallowKeywordActionObject);
    }

    return keywordActionObjectArray.flat();
}

type TBulkKeywordsObj = {
    selectedCampaignData: Array<string>;
    selectedAdgroupData: Array<string>;
    matchTypeData: Array<string>;
    action: string;
    actionLevel: string | number | Array<string>;
    isAdgroupSelectionRequired: boolean;
    isBidRequired: boolean;
};

function bulkOperationKeywordObject({
    selectedCampaignData,
    selectedAdgroupData,
    matchTypeData,
    action,
    actionLevel,
    isAdgroupSelectionRequired,
    isBidRequired,
}: TBulkKeywordsObj) {
    const keywords = checkForKeywordOrTarget(
        store.getState().keywordsSelectionData.value
    );
    const campaignsList = JSON.parse(
        window.sessionStorage.getItem("campaignList")
    );
    const adGroupsList = JSON.parse(
        window.sessionStorage.getItem("campaignAdgroupMapping")
    );

    // +Keywords
    // Keyword -> Campaign Level -> SP -> Adgroup Required
    // Target -> Campaign Level -> SP -> AdGroup Required
    // Keyword -> Campaign Level -> SB -> Adgroup Required
    // Target -> Campaign Level -> SB -> AdGroup Required
    // Keyword + Target -> Campaign Level -> SP -> AdGroup Required
    // Keyword + Target -> Campaign Level -> SB -> AdGroup Required

    // -Keywords
    // Keyword -> Campaign Level -> SP -> Adgroup Not Required
    // Target -> Campaign Level -> SP -> AdGroup Required
    // Keyword -> Campaign Level -> SB -> Adgroup Required
    // Target -> Campaign Level -> SB -> AdGroup Required
    // Keyword + Target -> Campaign Level -> SP -> AdGroup Required for Targets Only
    // Keyword + Target -> Campaign Level -> SB -> AdGroup Required

    const selectedCampaigns = campaignsList.filter(
        (campaignObject: TCampaign) =>
            selectedCampaignData.includes(campaignObject.sys_campaign_id)
    );

    const keywordsArray = keywords
        .map((keyword: TKeywordsActionObj) => {
            return selectedCampaigns.map((campaignObject: TCampaign) => {
                // check if Adgroup Info is required or not for each keyword
                if (
                    !isAdgroupInfoRequired({
                        actionLevel,
                        currentProgramType: campaignObject.program_type,
                        currentKeywordType: keyword.keyword_type,
                        isAdgroupSelectionRequired,
                    })
                ) {
                    return createKeywordActionObject({
                        keywordText: keyword.keyword_name,
                        programType: campaignObject.program_type,
                        keywordType: keyword.keyword_type,
                        campaignId: campaignObject.campaign_id,
                        sysCampaignId: campaignObject.sys_campaign_id,
                        channel_campaign_name:
                            campaignObject.channel_campaign_name,
                        adGroupId: null,
                        sysAdgroupId: null,
                        matchTypeData,
                        state: StateTypeValues.ENABLED,
                        action,
                        bid: isBidRequired ? getDefaultBid() : null,
                        targeting_type: campaignObject.targeting_type,
                    } as TKeywordsActionObj);
                } else {
                    return adGroupsList
                        .filter((adGroup: TAdGroup) =>
                            selectedAdgroupData.includes(adGroup.sys_adgroup_id)
                        )
                        .filter(
                            (adGroup: TAdGroup) =>
                                adGroup.campaign_id ===
                                campaignObject.campaign_id
                        )
                        .map((adGroup: TAdGroup) => {
                            if (
                                (adGroup.targeting_type === "manual" &&
                                    adGroup.manual_targeting_type ===
                                        "keyword" &&
                                    keyword.keyword_type === "keyword") ||
                                (adGroup.manual_targeting_type === "target" &&
                                    keyword.keyword_type === "asin") ||
                                adGroup.targeting_type === "auto"
                            ) {
                                return createKeywordActionObject({
                                    keywordText: keyword.keyword_name,
                                    programType: campaignObject.program_type,
                                    keywordType: keyword.keyword_type,
                                    campaignId: campaignObject.campaign_id,
                                    sysCampaignId:
                                        campaignObject.sys_campaign_id,
                                    channel_campaign_name:
                                        campaignObject.channel_campaign_name,
                                    adGroupId: adGroup.ad_group_id,
                                    sysAdgroupId: adGroup.sys_adgroup_id,
                                    ad_group_name: adGroup.ad_group_name,
                                    matchTypeData,
                                    state: StateTypeValues.ENABLED,
                                    action,
                                    bid: getDefaultBid(),
                                });
                                /**
                                 *! Code changed due to es-lint error check with mritunjay
                                 */
                            } else return [];
                        });
                }
            });
        })
        .flat(10)
        .filter((k) => k);
    return keywordsArray;
}

function removeDuplicateFromBulkKeywordArray(
    bulkKeywordArray: Array<TKeywordsActionObj>,
    action: string,
    actionLevel: string | number | Array<string>,
    programType: Array<Record<string, string>>
) {
    if (
        action === actions.addAsNegativeKeyword &&
        actionLevel === ActionLevel.Campaign &&
        programType.length === 1 &&
        programType.some((item) => item.program_type === ProgramType.SP)
    ) {
        const keywordTargets = bulkKeywordArray.filter(
            (targets: TKeywordsActionObj) =>
                targets.keywordType === ActionLevel.Keyword
        );

        const uniqueKeywordTargets = keywordTargets.reduce(
            (acc: Array<TKeywordsActionObj>, cur: TKeywordsActionObj) => {
                function isCampaignAlreadyPresent(obj: TKeywordsActionObj) {
                    return acc.some(
                        (item) =>
                            item.campaignId === obj.campaignId &&
                            item.matchType === obj.matchType &&
                            item.keywordText === obj.keywordText
                    );
                }

                if (isCampaignAlreadyPresent(cur)) {
                    return acc;
                } else {
                    delete cur["adGroupId"];
                    return [...acc, cur];
                }
            },
            []
        );

        const uniqueBulkKeywordArray = [
            ...bulkKeywordArray.filter(
                (targets: TKeywordsActionObj) => targets.keywordType === "asin"
            ),
            ...uniqueKeywordTargets,
        ];
        return uniqueBulkKeywordArray;
    } else {
        return bulkKeywordArray;
    }
}

function allowCustomTargetAddition(value: boolean) {
    document.getElementById("addKwdBtn").style.display = value
        ? "inline"
        : "none";
    const totalCustomTargetCount = store
        .getState()
        .keywordsSelectionData.value.filter((keyword) => keyword.custom).length;
    document.getElementById("remove-custom-targets").style.display =
        value && totalCustomTargetCount ? "unset" : "none";
}

const bulkKeywordColumnDefsInitial: Array<ColDef> = [
    {
        field: "keywordText",
        headerName: "Keyword name",
        minWidth: 300,
        maxWidth: 400,
        filter: "agTextColumnFilter",
        tooltipField: "keywordText",
        sortable: true,

        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        field: "programType",
        headerName: "Program Type",
        minWidth: 100,
        maxWidth: 150,
        filter: "agSetColumnFilter",
        sortable: true,
    },
    {
        field: "channel_campaign_name",
        headerName: "Campaign Name",
        minWidth: 300,
        maxWidth: 400,
        filter: "agTextColumnFilter",
        tooltipField: "channel_campaign_name",
        sortable: true,
    },
    {
        field: "keywordType",
        headerName: "Keyword Type",
        minWidth: 100,
        maxWidth: 120,
        filter: "agSetColumnFilter",
        tooltipField: "ad_group_name",
        sortable: true,
    },
];

function isValidKeyword(keyword: TKeywordsActionObj) {
    switch (keyword.matchType) {
        case "negativeExact":
            if (
                keyword.keywordText.split(" ").length <= 10 &&
                keyword.keywordText.length <= 80
            )
                return true;
            else return false;
        case "negativePhrase":
            if (
                keyword.keywordText.split(" ").length <= 4 &&
                keyword.keywordText.length <= 80
            )
                return true;
            else return false;
        default:
            return true;
    }
}

function negativeKeywordMatchTypeConstraint(
    bulkKeywordArray: Array<TKeywordsActionObj>
) {
    return bulkKeywordArray.filter((keyword) => isValidKeyword(keyword));
}

function showDuplicacyWarning(duplicacyCount: number) {
    if (duplicacyCount) {
        showToast(
            "danger",
            `${duplicacyCount} duplicate combinations has been removed from the addition request`
        );
    }
}

export const reviewSelectionHandler = async (
    selectedMatchType: Array<TSelectedValue>,
    programType: Array<Record<string, string>>,
    selectedAdgroups: Array<TSelectedValue>,
    bulkKeywordsGridApi: GridApi,
    setBulkKeywordColumnDefs: React.Dispatch<
        React.SetStateAction<Array<ColDef>>
    >,
    setBulkKeywordsRowData: React.Dispatch<
        React.SetStateAction<Array<TKeywordsActionObj>>
    >,
    setFooterBtnValues: React.Dispatch<
        React.SetStateAction<TBulkActionsFooterBtnValues>
    >,
    setKaModalStepCount: React.Dispatch<React.SetStateAction<number>>,
    selectedActionLevel: string,
    isAdgroupSelectionRequired: boolean,
    isBidRequired: boolean,
    isMatchTypeReviewRequired: boolean,
    isMatchTypeSelectionRequired: boolean,
    excludedBidProgramType: string[] | null
) => {
    if (excludedBidProgramType?.length && programType.length === 1) {
        programType.map((program: Record<string, string>) => {
            if (excludedBidProgramType.includes(program.value)) {
                isBidRequired = false;
            }
        });
    }
    let selectedAdgroupValues: Array<string> = [];

    /**
     * * Resetting matchTypeArray and selectedAdgroupValues to prevent duplication, when clicked on review button
     */

    matchTypeArray = [];
    selectedAdgroupValues = [];

    selectedMatchType.forEach((type) => {
        matchTypeArray.push(type.value);
    });

    if (selectedAdgroups) {
        selectedAdgroups.forEach((options) => {
            selectedAdgroupValues.push(options.value);
        });
    }

    const actionLevel = isAdgroupSelectionRequired
        ? selectedActionLevel
        : "campaign";

    const selectedKeyword = checkForKeywordOrTarget(
        store.getState().keywordsSelectionData.value
    );
    // map the campaigns to the adgroups at review-selection page since adgroup is required as well for product-targeting

    // * Check if adgroup-info is required or not by filtering out any any entity which needs adgroups info over
    // * all the selected-keywords

    const campaignsList = JSON.parse(
        window.sessionStorage.getItem("campaignList")
    );

    const selectedCampaigns = campaignsList.filter(
        (campaignObject: TCampaign) =>
            selectedCampaignArray.includes(campaignObject.sys_campaign_id)
    );

    const fetchAdgroupInfo = !!selectedKeyword.filter(
        (keyword: TKeywordsActionObj) =>
            !!selectedCampaigns.filter((campaignObj: TCampaign) =>
                isAdgroupInfoRequired({
                    actionLevel,
                    currentProgramType: campaignObj.program_type,
                    currentKeywordType: keyword.keyword_type,
                    isAdgroupSelectionRequired,
                })
            ).length
    ).length;
    // * If adgroup info is required, fetch it in a (sort of) blocking way, out side the loop and set "campaignAdgroupMapping" in session-storage

    if (fetchAdgroupInfo) {
        await getCampaignSpecificAdgroup(selectedCampaignArray);
        selectedAdgroupArray =
            actionLevel === "adgroup"
                ? selectedAdgroupValues
                : JSON.parse(
                      window.sessionStorage.getItem("campaignAdgroupMapping")
                  ).map((adgroupInfo: TAdGroup) => adgroupInfo.sys_adgroup_id);
    } else {
        selectedAdgroupArray = [];
    }

    const sponsoredBrandAdgroups = JSON.parse(
        window.sessionStorage.getItem("sponsoredBrandAdgroups")
    );

    if (sponsoredBrandAdgroups && sponsoredBrandAdgroups.length) {
        sponsoredBrandAdgroups.forEach((adgroupInfo: TAdGroup) => {
            selectedAdgroupArray.push(adgroupInfo.sys_adgroup_id);
        });
    }

    //@ts-ignore
    selectedAdgroupArray = [...new Set(selectedAdgroupArray)];

    let bulkKeywordArray = await createBulkKeywordObject(
        selectedCampaignArray,
        selectedAdgroupArray,
        actionLevel,
        isAdgroupSelectionRequired,
        isBidRequired
    );

    if (bulkKeywordArray.length) {
        //Instamart matchtype checks
        //- if a keyword exists already as any matchtype then filter it out from the combination
        //- Same keyword cannot be added as two different match types within a same campaign
        if (
            isMatchTypeReviewRequired &&
            actionType === BULK_TGT_ACTION.ADD_AS_KEYWORD
        ) {
            bulkKeywordArray = await getFilteredKeywords(
                selectedCampaignArray,
                bulkKeywordArray
            );
        }

        if (excludedBidProgramType?.length) {
            bulkKeywordArray = bulkKeywordArray.filter(
                (keyword: TKeywordsActionObj) => {
                    const isPCACampaign =
                        keyword.targeting_type === ProgramType.PCA;
                    if (excludedBidProgramType.includes(keyword.programType)) {
                        if (
                            !isPCACampaign &&
                            (keyword.matchType === MatchType.EXACT ||
                                keyword.matchType === MatchType.NEGATIVE_PHRASE)
                        ) {
                            return false;
                        } else {
                            delete keyword.bid;
                            return true;
                        }
                    }
                    return true;
                }
            );
            bulkKeywordArray.map((keyword: TKeywordsActionObj) => {
                delete keyword.targeting_type;
            });
        }

        //- In -veKeywordAddition, at campaign level, in SP, duplicate objects are present.
        //- Reason being the varying adgroups in a campaign.
        //- This function below remove these duplicates
        bulkKeywordArray = removeDuplicateFromBulkKeywordArray(
            bulkKeywordArray,
            actionType,
            actionLevel,
            programType
        );
        allowCustomTargetAddition(false);
        setKaModalStepCount(2);
        $("#keyword-analytics-second-step-loader").show();

        const adGroupNameField = {
            field: "ad_group_name",
            headerName: "Adgroup Name",
            minWidth: 300,
            maxWidth: 400,
            filter: "agTextColumnFilter",
            tooltipField: "ad_group_name",
            sortable: true,
        };

        const bidValueField = {
            field: "bid",
            sortable: true,
            headerName: "Bid",
            maxWidth: 250,
            filter: "agNumberColumnFilter",
            tooltipField: "bid",

            cellRenderer: UpdateWithInputCellRenderer,
            cellRendererParams: {
                hasApplyButton: false,
                hasCancelButton: false,
                isThirdPartyRequestOnApply: false,
                origin: "bulk-keyword-addition",
            },
        };

        const matchTypeField = {
            field: "matchType",
            headerName: "Match Type",
            minWidth: 120,
            maxWidth: 200,
            filter: "agSetColumnFilter",
            tooltipField: "matchType",
            sortable: true,
        };

        const bulkKeywordColumnDefs = [...bulkKeywordColumnDefsInitial];
        if (isMatchTypeSelectionRequired) {
            bulkKeywordColumnDefs.push(matchTypeField);
        }
        if (actionLevel === "adgroup") {
            if (bulkKeywordColumnDefs.length === 5) {
                bulkKeywordColumnDefs.push(adGroupNameField);
            }
        }

        if (isBidRequired && actionType === actions.addAsKeyword) {
            bulkKeywordColumnDefs.push(bidValueField);
        } else if (actionType === actions.addAsNegativeKeyword) {
            bulkKeywordColumnDefs.forEach((colDef) =>
                colDef.field === "bid" ? (colDef.hide = true) : ""
            );
        }

        if (actionLevel === "campaign" && bulkKeywordColumnDefs.length >= 6) {
            bulkKeywordColumnDefs.forEach((colDef) =>
                colDef.field === "ad_group_name" ? (colDef.hide = true) : ""
            );
        }

        try {
            setBulkKeywordColumnDefs(bulkKeywordColumnDefs);

            let uniqueSelectedKeywordsArray = [];

            if (window.Worker) {
                uniqueSelectedKeywordsArray = (await createWorkers(
                    "bulkKeywords",
                    bulkKeywordArray
                )) as Array<string>;
            } else {
                uniqueSelectedKeywordsArray =
                    removeDuplicateObjects(bulkKeywordArray);
            }

            if (uniqueSelectedKeywordsArray.length) {
                setBulkKeywordsRowData(
                    negativeKeywordMatchTypeConstraint(
                        uniqueSelectedKeywordsArray
                    )
                );

                if (
                    uniqueSelectedKeywordsArray.length !==
                    bulkKeywordArray.length
                ) {
                    showDuplicacyWarning(
                        bulkKeywordArray.length -
                            uniqueSelectedKeywordsArray.length
                    );
                }

                $("#keyword-analytics-second-step-loader").hide();
                setFooterBtnValues((prev) => ({
                    ...prev,
                    isBackBtnVisible: true,
                }));
                setKaModalStepCount(2);
                setFooterBtnValues((prev) => ({
                    ...prev,
                    isReviewSelectionBtnVisible: false,
                }));
            }
        } catch (err) {
            console.error(err);
            showToast("danger", (err as Error).message);
        }
    } else {
        setFooterBtnValues((prev) => ({
            ...prev,
            isReviewSelectionBtnDisabled: true,
        }));
        showToast(
            "danger",
            "No any selection available for selected combination of operations"
        );
    }
};

async function sendBulkKeywords(
    selectedKeywordsArray: TCommonRowData,
    action: string,
    event: React.MouseEvent<HTMLButtonElement>,
    isAdgroupSelectionRequired: boolean,
    isBidRequired: boolean,
    isMatchTypeSelectionRequired: boolean
) {
    try {
        const selectedKeywordObjects: Record<string, TCommonRowObj[]> = {
            keywords: [],
            targets: [],
            campaignKeywords: [],
        };
        const redundantKey = [
            "keywordType",
            "ad_group_name",
            "channel_campaign_name",
            "targeting_type",
            ...(!isBidRequired ? ["bid"] : []),
            ...(!isMatchTypeSelectionRequired ? ["matchType"] : []),
        ];

        selectedKeywordsArray.forEach((keywordObject: TCommonRowObj) => {
            if (keywordObject.keywordType === "keyword") {
                if (
                    Object.prototype.hasOwnProperty.call(
                        keywordObject,
                        "adGroupId"
                    ) ||
                    !isAdgroupSelectionRequired
                ) {
                    selectedKeywordObjects.keywords.push(keywordObject);
                } else {
                    selectedKeywordObjects.campaignKeywords.push(keywordObject);
                }
            } else {
                selectedKeywordObjects.targets.push(keywordObject);
            }
            redundantKey.forEach((key) => delete keywordObject[key]);
        });

        Object.keys(selectedKeywordObjects).forEach((key) =>
            !selectedKeywordObjects[key].length
                ? delete selectedKeywordObjects[key]
                : ""
        );

        const response =
            action === "addAsNegativeKeyword"
                ? await createNegativeKeywords(selectedKeywordObjects)
                : await validateCreateKeywords(selectedKeywordObjects);
        if (response.status) {
            let message;
            if (response.metadata) {
                if (action === "addAsNegativeKeyword") {
                    message = `${response.metadata.keywordsAndTargets.success}/${response.metadata.keywordsAndTargets.total} negative keywords and targets are successfully created.`;
                    showToast("success", message);
                } else {
                    const keywordsToUpdate =
                        response.metadata.keywordsAndTargetsToProcess.toUpdate;
                    const keywordsToCreate =
                        response.metadata.keywordsAndTargetsToProcess.toCreate;
                    if (keywordsToUpdate.length) {
                        const finalKeywordsArray: Record<
                            string,
                            string | string[]
                        >[] = processCreateKeywordsReviewData(keywordsToUpdate);

                        store.dispatch(
                            setCreateKeywordsReviewData(finalKeywordsArray)
                        );
                        store.dispatch(setCreateKeywordsData(keywordsToCreate));

                        store.dispatch(
                            updateShowCreateKeywordsReviewDisplay(true)
                        );
                    } else {
                        const createKeywordResponse = await createKeywords(
                            selectedKeywordObjects
                        );
                        if (createKeywordResponse.status) {
                            message = createKeywordResponse.metadata
                                ? `${createKeywordResponse.metadata.keywords.success}/${createKeywordResponse.metadata.keywords.total} keywords and 
                                    ${createKeywordResponse.metadata.targets.success}/${createKeywordResponse.metadata.targets.total} targets are successfully created.`
                                : createKeywordResponse.message;
                            showToast("success", message);
                        } else {
                            showToast(
                                "danger",
                                createKeywordResponse.isUserRestricted
                                    ? `Unable to add keywords in bulk: ${createKeywordResponse.message}`
                                    : "Unable to add keywords in bulk"
                            );
                        }
                    }
                }
            } else {
                showToast("success", response.message);
            }
        } else {
            action === "addAsNegativeKeyword"
                ? showToast(
                      "danger",
                      response.isUserRestricted
                          ? `Unable to add negative keywords in bulk: ${response.message}`
                          : "Unable to add negative keywords in bulk"
                  )
                : response.isIndividualCreateReq
                ? showToast(
                      "danger",
                      response.isUserRestricted
                          ? `Operation keyword creation failed: ${response.message}`
                          : response.message
                  )
                : showToast(
                      "danger",
                      response.isUserRestricted
                          ? `Unable to add keywords in bulk: ${response.message}`
                          : "Unable to add keywords in bulk"
                  );
        }
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
    }
    setSpinner("remove", event, true);
}

const processCreateKeywordsReviewData = (
    keywordsToUpdate: Record<string, string>[]
) => {
    const campaignsList = JSON.parse(
        window.sessionStorage.getItem("campaignList")
    );
    const campaignAdgroupMapping = JSON.parse(
        window.sessionStorage.getItem("campaignAdgroupMapping")
    );

    return map(keywordsToUpdate, (keyword) => ({
        keywordId: keyword.keywordId,
        campaignId: keyword.campaignId.toString(),
        adGroupId: keyword.adGroupId.toString(),
        keywordName: keyword.keywordText,
        campaignName: find(
            campaignsList,
            (campaign) => keyword.sysCampaignId === campaign.sys_campaign_id
        ).channel_campaign_name,
        adgroupName: find(
            campaignAdgroupMapping,
            (adgroup) => keyword.sysAdgroupId === adgroup.sys_adgroup_id
        ).ad_group_name,
        matchType: keyword.matchType,
        existingBid: keyword.existingBid,
        newBid: keyword.bid,
    }));
};

export const bulkKeywordsClickHandler = (
    gridApi: GridApi,
    event: React.MouseEvent<HTMLButtonElement>,
    isAdgroupSelectionRequired: boolean,
    isBidRequired: boolean,
    isMatchTypeSelectionRequired: boolean
) => {
    const selectedRows = JSON.parse(JSON.stringify(gridApi.getSelectedRows()));
    sendBulkKeywords(
        selectedRows,
        actionType,
        event,
        isAdgroupSelectionRequired,
        isBidRequired,
        isMatchTypeSelectionRequired
    );
};

export const reviewActionClickHandler = async (
    createKeywordsReviewData: ICreateReviewKeywords[],
    createKeywordsData: TCommonRowObj[],
    event: React.MouseEvent<HTMLButtonElement>
) => {
    try {
        const updateKeywordsData = {
            keywords: map(createKeywordsReviewData, (keyword) => ({
                keywordId: keyword.keywordId.toString(),
                changeType: "absolute",
                changeValue: Number(
                    $(
                        `#newBid-${keyword.keywordId}_${keyword.matchType}-update-field`
                    ).val()
                ),
                attribute: ["bid"],
            })),
        };

        const selectedKeywordObjects: Record<string, TCommonRowObj[]> = {
            keywords: [],
            targets: [],
        };

        if (createKeywordsData.length) {
            createKeywordsData.forEach((keyword: TCommonRowObj) => {
                keyword.matchType !== "asinSameAs"
                    ? selectedKeywordObjects.keywords.push(keyword)
                    : selectedKeywordObjects.targets.push(keyword);
            });
        }

        Object.keys(selectedKeywordObjects).forEach((key) => {
            if (!selectedKeywordObjects[key].length) {
                delete selectedKeywordObjects[key];
            }
        });

        const responses = await Promise.all(
            createKeywordsData.length
                ? [
                      createKeywords(selectedKeywordObjects),
                      updateKeywords(updateKeywordsData),
                  ]
                : [updateKeywords(updateKeywordsData)]
        );

        const responseArr: string[] = [];
        let successCount = 0;
        let message = "";
        if (createKeywordsData.length) {
            responses.forEach((response, index) => {
                if (response.status) {
                    successCount++;
                    const { keywords, targets } =
                        response.metadata || response.success;
                    responseArr.push(
                        `${keywords.success}/${keywords.total} keywords and 
                        ${targets.success}/${targets.total} targets 
                        ${index ? "updated" : "created"} successfully.`
                    );
                }
            });

            message = responseArr.join(" ");
        } else {
            const updateResponse = responses[0];
            if (updateResponse.status) {
                successCount++;
                const { keywords, targets } =
                    updateResponse.metadata || updateResponse.success;
                message = `
                    ${keywords.success}/${keywords.total} keywords and 
                    ${targets.success}/${targets.total} targets 
                    updated successfully.
                `;
            }
        }

        const finalMessage = message
            ? message
            : "Operation keyword creation failed";

        showToast(
            responses.length === successCount ? "success" : "danger",
            finalMessage
        );

        setSpinner("remove", event, true);

        store.dispatch(updateShowCreateKeywordsReviewDisplay(false));
    } catch {
        setSpinner("remove", event, true);
    }
};

export const backButtonClickHandler = (
    setFooterBtnValues: React.Dispatch<
        React.SetStateAction<TBulkActionsFooterBtnValues>
    >,
    setKaModalStepCount: React.Dispatch<React.SetStateAction<number>>
) => {
    allowCustomTargetAddition(true);
    setKaModalStepCount(1);
    setFooterBtnValues((prev) => ({
        ...prev,
        isReviewSelectionBtnVisible: true,
        isAddNegativeKeywordBtnVisible: false,
        isAddKeywordBtnVisible: false,
        isBackBtnVisible: false,
    }));
};

//- Instamart allows keywords to be added as a single match type only
//- So filtered out the keywords that already exist as any match type within a particular campaign

const getFilteredKeywords = async (
    campaigns: string[],
    bulkKeywords: TKeywordsActionObj[]
) => {
    try {
        //check 1 - if the keyword exists within the campaign as any match type
        const reviewedKeywords = await getReviewedKeywords(campaigns);
        const reviewdKeywordsSet = new Set(
            map(
                reviewedKeywords,
                (keyword) =>
                    `${keyword.sys_campaign_id}:${keyword.keyword_name}`
            )
        );

        //keywords after first filter check
        const filteredKeywords = filter(
            bulkKeywords,
            (keyword) =>
                !reviewdKeywordsSet.has(
                    `${keyword.sysCampaignId}:${keyword.keywordText}`
                )
        );

        //check 2 - allow keyword to be added as only a single match type within a campaign
        const keywordMap = new Map();
        forEach(filteredKeywords, (keyword: TKeywordsActionObj) => {
            const key = `${keyword.campaignId}-${keyword.keywordText}`;
            if (!keywordMap.has(key) || keyword.matchType === "exact") {
                keywordMap.set(key, keyword);
            }
        });

        //keywords after second filter check
        const finalFilteredKeywords = Array.from(keywordMap.values());

        showDuplicacyWarning(
            bulkKeywords.length - finalFilteredKeywords.length
        );
        return finalFilteredKeywords;
    } catch (err: any) {
        throw new Error(err.message);
    }
};
